/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrganizationEmailSettingsResource } from '../models/OrganizationEmailSettingsResource'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class OrganizationsEmailSettingsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getOrganizationEmailSettings({
        organization
    }: {
        /**
         * Organization ID
         */
        organization: number
    }): CancelablePromise<{
        data: OrganizationEmailSettingsResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organization}/email-settings',
            path: {
                organization: organization
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public updateOrganizationEmailSettings({
        organization,
        requestBody
    }: {
        /**
         * Organization ID
         */
        organization: number
        requestBody?: {
            compose_email_disabled?: boolean
            fraud_whitelisted?: boolean
            /**
             * Applies (or clears) a fixed -0.5%, 30-day spam-percent offset.
             */
            spam_offset_active?: boolean
        }
    }): CancelablePromise<{
        data: OrganizationEmailSettingsResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/organizations/{organization}/email-settings',
            path: {
                organization: organization
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
